// extracted by mini-css-extract-plugin
export default {"paperBlock":"style_paperBlock__Gor9y"};